























































































































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { AuthorizationList, StudioState } from "../interfaces/studioState";
import { StudioService } from "../services/roomService";
import { FileService } from "@/services/fileService";
import ConfirmDeleteDialog from "../components/customActions/ConfirmDeleteDialog.vue";
import BackgroundSettings from "@/interfaces/studioBackground";

@Component({ components: { ConfirmDeleteDialog } })
export default class StudioManagerEditForm extends Vue {
    @Prop() dialogActive!: boolean;
    @Prop() studio!: StudioState;

    public errors = { allowList: false, blockList: false };
    public lists: AuthorizationList | null = null;
    public deleteDialogActive: boolean = false;
    public backgroundsizes: string[] = [
        "contain",
        "auto",
        "cover",
        "75%",
        "50%",
        "25%",
        "10%",
    ];
    public backgroundpositions: string[] = [
        "center",
        "top left",
        "top right",
        "bottom left",
        "bottom right",
    ];
    public get backgroundSizeValue(): string {
        return this.studio.backgroundSettings?.size || "contain";
    }

    public set backgroundSizeValue(newValue: string) {
        if (this.studio.backgroundSettings)
            this.studio.backgroundSettings.size = newValue;
    }

    public get backgroundPositionValue(): string {
        return this.studio.backgroundSettings?.position || "center";
    }

    public set backgroundPositionValue(newValue: string) {
        if (this.studio.backgroundSettings)
            this.studio.backgroundSettings.position = newValue;
    }

    token: string = "";
    tab: null = null;

    public get showDialog(): boolean {
        return this.dialogActive;
    }
    public set showDialog(e: boolean) {
        this.done();
    }
    public get rules() {
        return [
            (value: File) =>
                !value ||
                (value.name as string).includes(".csv") ||
                this.$t("studio.manager.csvOnly"),
        ];
    }

    public get userlikeChatActive(): boolean {
        if (this.studio.attributes.userLikeChatWidgetId) {
            return true;
        }
        return false;
    }

    public set userlikeChatActive(e: boolean) {
        if (e) {
            this.studio.attributes.userLikeChatWidgetId = this.$store.state.user.userLikeChatWidgetId;
        } else {
            this.studio.attributes.userLikeChatWidgetId = null;
        }
        this.changeStudioAttributes();
    }

    public async mounted() {
        this.token = await this.$auth.getTokenSilently();
        StudioService.authorizationLists(this.studio.studioId, this.token).then(
            r => {
                this.lists = r;
            }
        );
    }

    public async changeAuthorizationActive(e: boolean) {
        await StudioService.changeAuthorizationActive(
            this.studio.studioId,
            e,
            this.token
        );
    }
    public async updateStudioName() {
        await StudioService.changeName(
            this.studio.studioId,
            this.studio.studioName,
            this.token
        );
        this.$store.commit("showSnackbar", {
            text: this.$t("studio.manager.nameUpdated", {
                newName: this.studio.studioName,
            }),
            color: "success",
        });
    }

    public async fileReady(f: File, type: string) {
        StudioService.changeAuthorization(
            type,
            this.studio.studioId,
            this.token,
            f
        )
            .then(r => {
                if (r.status == 200) {
                    this.$store.commit("showSnackbar", {
                        text: this.$t("studio.manager.addedList", {
                            listType: type,
                        }),
                        color: "success",
                    });
                    if (type == "allowList") {
                        this.errors.allowList = false;
                    } else this.errors.blockList = false;
                } else {
                    this.$store.commit("showSnackbar", {
                        text: r.data.detail,
                        color: "error",
                    });
                    if (type == "allowList") {
                        this.errors.allowList = true;
                    } else this.errors.blockList = true;
                }
                // update lists
                StudioService.authorizationLists(
                    this.studio.studioId,
                    this.token
                ).then(r => {
                    this.lists = r;
                });
            })
            .catch(e => console.log("bad handling", e));
    }
    public async clearAll() {
        const clearAllow = await StudioService.changeAuthorization(
            "allowList",
            this.studio.studioId,
            this.token
        );
        const clearBlock = await StudioService.changeAuthorization(
            "blockList",
            this.studio.studioId,
            this.token
        );
        Promise.all([clearAllow, clearBlock]).then(() => {
            StudioService.authorizationLists(
                this.studio.studioId,
                this.token
            ).then(r => {
                this.lists = r;
            });
        });
    }

    public uploadBackground(f: File) {
        FileService.uploadFile(this.studio.studioId, f).then(r => {
            if (r.status == 200) {
                this.changeBackgroundSettings({
                    image: r.data.id,
                    position: this.backgroundPositionValue,
                    size: this.backgroundSizeValue,
                });
            }
        });
    }

    public changeSizeOrPosition() {
        this.changeBackgroundSettings({
            image: this.studio.backgroundSettings?.image || "",
            position: this.backgroundPositionValue,
            size: this.backgroundSizeValue,
        });
    }

    public changeBackgroundSettings(backgroundSettings: BackgroundSettings) {
        this.$store.commit("showSnackbar", {
            text: this.$t("studio.manager.backgroundUpdated"),
            color: "success",
        });

        this.changeBackground(backgroundSettings);
        this.studio.backgroundSettings = backgroundSettings;
    }

    public async removeBackground(confirmation: boolean) {
        if (confirmation) {
            this.$store.commit("showSnackbar", {
                text: this.$t("studio.manager.backgroundRemoved"),
                color: "warning",
            });

            this.changeBackground(null);
            this.studio.backgroundSettings = null;
        }
        this.deleteDialogActive = false;
    }

    @Emit() changeBackground(newBackground: BackgroundSettings | null) {
        return { background: newBackground, studioId: this.studio.studioId };
    }

    @Emit() changeStudioAttributes() {
        return {
            studioId: this.studio.studioId,
            attributes: this.studio.attributes,
        };
    }

    @Emit() done() {
        return "";
    }
}
